import FullscreenOverlay from "shared/components/FullscreenOverlay";
import Modal from "reflux/okmodal/components/Modal";
import PropTypes from "prop-types";
import React, { Component } from "react";

class ModalApp extends Component {
	render() {
		return (
			<div>
				{this.props.windowshade &&
					<FullscreenOverlay />
				}
				<Modal {...this.props} />
			</div>
		);
	}
}

ModalApp.propTypes = {
	windowshade: PropTypes.bool,
};

export default ModalApp;



// WEBPACK FOOTER //
// ./src/reflux/okmodal/components/App.jsx